import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "Footer-inner" }
const _hoisted_2 = { class: "Footer-row--1 grid" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("div", { class: "Footer-left" }, [
  /*#__PURE__*/_createElementVNode("picture", { class: "Footer-logo" }, [
    /*#__PURE__*/_createElementVNode("source", { srcset: "/dev/logo-pernord-ricard.png 1x, /dev/logo-pernord-ricard@2x.png 2x" }),
    /*#__PURE__*/_createElementVNode("img", {
      src: "/dev/logo-pernord-ricard.png",
      alt: "Logo Pernod Ricard"
    })
  ])
], -1)
const _hoisted_4 = { class: "Footer-right" }
const _hoisted_5 = { class: "Footer-socials" }
const _hoisted_6 = ["href"]
const _hoisted_7 = /*#__PURE__*/_createElementVNode("svg", {
  width: "11",
  height: "20",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, [
  /*#__PURE__*/_createElementVNode("path", {
    "fill-rule": "evenodd",
    "clip-rule": "evenodd",
    d: "M2.445 11.053V20h4.63v-8.904h3.16L11 7.382H7.109V4.659c0-.375.212-.879.86-.879h2.25V0h-4.2c-1.451 0-3.59 1.678-3.59 3.462v3.816H0v3.76l2.445.016v-.001Z",
    fill: "#fff"
  })
], -1)
const _hoisted_8 = [
  _hoisted_7
]
const _hoisted_9 = ["href"]
const _hoisted_10 = /*#__PURE__*/_createElementVNode("svg", {
  width: "20",
  height: "16",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, [
  /*#__PURE__*/_createElementVNode("path", {
    d: "M6.292 16c7.545 0 11.673-6.156 11.673-11.493 0-.173-.004-.35-.012-.523A8.262 8.262 0 0 0 20 1.892a8.19 8.19 0 0 1-2.355.635A4.073 4.073 0 0 0 19.449.293a8.326 8.326 0 0 1-2.605.98 4.129 4.129 0 0 0-2.328-1.22 4.165 4.165 0 0 0-2.601.425 4.072 4.072 0 0 0-1.803 1.895 3.988 3.988 0 0 0-.262 2.584 11.797 11.797 0 0 1-4.683-1.225A11.622 11.622 0 0 1 1.394.74 3.99 3.99 0 0 0 .946 3.68 4.045 4.045 0 0 0 2.664 6.13a4.158 4.158 0 0 1-1.86-.504v.05a4 4 0 0 0 .928 2.56 4.113 4.113 0 0 0 2.365 1.401 4.14 4.14 0 0 1-1.851.07 4.05 4.05 0 0 0 1.459 2.007 4.154 4.154 0 0 0 2.372.8A8.312 8.312 0 0 1 0 14.185 11.775 11.775 0 0 0 6.292 16Z",
    fill: "#fff"
  })
], -1)
const _hoisted_11 = [
  _hoisted_10
]
const _hoisted_12 = ["href"]
const _hoisted_13 = /*#__PURE__*/_createElementVNode("svg", {
  width: "20",
  height: "20",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, [
  /*#__PURE__*/_createElementVNode("path", {
    d: "M10.006 1.801c2.673 0 2.99.012 4.041.059.977.043 1.505.207 1.857.344.465.18.801.398 1.149.746.352.351.567.684.746 1.148.137.352.301.883.344 1.856.047 1.055.06 1.372.06 4.04 0 2.672-.013 2.989-.06 4.04-.043.977-.207 1.504-.344 1.856-.18.465-.398.8-.746 1.148a3.078 3.078 0 0 1-1.15.747c-.35.137-.883.3-1.856.343-1.055.047-1.372.06-4.041.06-2.674 0-2.99-.013-4.042-.06-.977-.042-1.504-.206-1.856-.343a3.094 3.094 0 0 1-1.15-.747 3.076 3.076 0 0 1-.746-1.148c-.137-.352-.3-.883-.344-1.856-.047-1.055-.058-1.371-.058-4.04 0-2.672.011-2.989.058-4.04.043-.976.207-1.504.344-1.856.18-.464.399-.8.747-1.148a3.078 3.078 0 0 1 1.149-.746c.352-.137.883-.301 1.856-.344 1.052-.047 1.368-.059 4.042-.059Zm0-1.801C7.289 0 6.949.012 5.882.059 4.82.105 4.088.277 3.455.524c-.66.257-1.22.597-1.774 1.156A4.9 4.9 0 0 0 .524 3.45C.278 4.087.106 4.813.059 5.876.012 6.946 0 7.286 0 10.002c0 2.715.012 3.055.059 4.122.047 1.063.219 1.793.465 2.426.258.66.598 1.22 1.157 1.774a4.892 4.892 0 0 0 1.77 1.152c.637.247 1.364.419 2.427.465 1.067.047 1.408.059 4.124.059 2.716 0 3.056-.012 4.123-.059 1.064-.046 1.794-.218 2.428-.464a4.892 4.892 0 0 0 1.77-1.153 4.89 4.89 0 0 0 1.153-1.77c.247-.637.419-1.363.465-2.426.047-1.067.059-1.407.059-4.122 0-2.716-.012-3.055-.059-4.122-.046-1.063-.218-1.793-.465-2.426a4.685 4.685 0 0 0-1.145-1.778 4.892 4.892 0 0 0-1.77-1.153C15.923.281 15.196.11 14.133.063 13.063.012 12.723 0 10.006 0Z",
    fill: "#fff"
  }),
  /*#__PURE__*/_createElementVNode("path", {
    d: "M10.005 4.864a5.14 5.14 0 0 0-5.14 5.138 5.14 5.14 0 0 0 10.28 0 5.14 5.14 0 0 0-5.14-5.138Zm0 8.47a3.334 3.334 0 1 1 0-6.667 3.334 3.334 0 0 1 0 6.668ZM16.548 4.661a1.2 1.2 0 1 1-2.4 0 1.2 1.2 0 0 1 2.4 0Z",
    fill: "#fff"
  })
], -1)
const _hoisted_14 = [
  _hoisted_13
]
const _hoisted_15 = ["href"]
const _hoisted_16 = /*#__PURE__*/_createElementVNode("svg", {
  width: "20",
  height: "20",
  viewBox: "0 0 20 20",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, [
  /*#__PURE__*/_createElementVNode("path", {
    d: "M14.2274 0H10.8568V13.6232C10.8568 15.2464 9.56048 16.5797 7.94721 16.5797C6.33394 16.5797 5.03757 15.2464 5.03757 13.6232C5.03757 12.029 6.30513 10.7246 7.8608 10.6667V7.24639C4.43259 7.30433 1.66699 10.1159 1.66699 13.6232C1.66699 17.1594 4.49021 20 7.97603 20C11.4618 20 14.285 17.1304 14.285 13.6232V6.63767C15.5526 7.56522 17.1082 8.11594 18.7503 8.14495V4.72464C16.2152 4.63768 14.2274 2.55072 14.2274 0Z",
    fill: "white"
  })
], -1)
const _hoisted_17 = [
  _hoisted_16
]
const _hoisted_18 = { class: "Footer-row--2 grid" }
const _hoisted_19 = { class: "Footer-left" }
const _hoisted_20 = ["innerHTML"]
const _hoisted_21 = { class: "Footer-right Footer-right--bottom" }
const _hoisted_22 = { class: "Footer-links" }
const _hoisted_23 = { class: "Footer-row--3 grid" }
const _hoisted_24 = { class: "Footer-right Footer-right--alt" }
const _hoisted_25 = { class: "Footer-links Footer-links--alt" }
const _hoisted_26 = {
  target: "_blank",
  rel: "noreferrer",
  href: "https://www.pernod-ricard.com/en/locations/usa/pernod-ricard-usa-website-terms-use",
  class: "Footer-links-item--alt link-secondary--alt text-sm"
}
const _hoisted_27 = {
  href: "https://privacy.pernod-ricard-usa.com/",
  class: "Footer-links-item--alt link-secondary--alt text-sm"
}
const _hoisted_28 = { class: "Footer-row--4 grid" }
const _hoisted_29 = { class: "Footer-left" }
const _hoisted_30 = ["innerHTML"]
const _hoisted_31 = { class: "Footer-responsability Footer-right" }
const _hoisted_32 = ["innerHTML"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_RouterLink = _resolveComponent("RouterLink")!

  return (_openBlock(), _createElementBlock("footer", {
    class: _normalizeClass([{ 'light': _ctx.theme === 'light' }, "Footer"])
  }, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _hoisted_3,
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("ul", _hoisted_5, [
            _createElementVNode("li", null, [
              _createElementVNode("a", {
                onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.onSocialClick('facebook'))),
                href: _ctx.$t('footer.facebook'),
                target: "_blank",
                class: "Footer-socials-link"
              }, _hoisted_8, 8, _hoisted_6)
            ]),
            _createElementVNode("li", null, [
              _createElementVNode("a", {
                onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.onSocialClick('twitter'))),
                href: _ctx.$t('footer.twitter'),
                target: "_blank",
                class: "Footer-socials-link"
              }, _hoisted_11, 8, _hoisted_9)
            ]),
            _createElementVNode("li", null, [
              _createElementVNode("a", {
                onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.onSocialClick('instagram'))),
                href: _ctx.$t('footer.instagram'),
                target: "_blank",
                class: "Footer-socials-link"
              }, _hoisted_14, 8, _hoisted_12)
            ]),
            _createElementVNode("li", null, [
              _createElementVNode("a", {
                onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.onSocialClick('tiktok'))),
                href: _ctx.$t('footer.tiktok'),
                target: "_blank",
                class: "Footer-socials-link"
              }, _hoisted_17, 8, _hoisted_15)
            ])
          ])
        ])
      ]),
      _createElementVNode("div", _hoisted_18, [
        _createElementVNode("div", _hoisted_19, [
          _createElementVNode("span", {
            class: "h2",
            innerHTML: _ctx.$t('footer.description')
          }, null, 8, _hoisted_20)
        ]),
        _createElementVNode("div", _hoisted_21, [
          _createElementVNode("ul", _hoisted_22, [
            _createElementVNode("li", null, [
              _createVNode(_component_RouterLink, {
                to: "/company",
                class: "Footer-links-item h5 link--alt"
              }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_ctx.$t('footer.company')), 1)
                ]),
                _: 1
              })
            ]),
            _createElementVNode("li", null, [
              _createVNode(_component_RouterLink, {
                to: "/contact",
                class: "Footer-links-item h5 link--alt"
              }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_ctx.$t('footer.contact')), 1)
                ]),
                _: 1
              })
            ]),
            _createElementVNode("li", null, [
              _createVNode(_component_RouterLink, {
                to: "/faq",
                class: "Footer-links-item h5 link--alt"
              }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_ctx.$t('footer.faqs')), 1)
                ]),
                _: 1
              })
            ])
          ])
        ])
      ]),
      _createElementVNode("div", _hoisted_23, [
        _createElementVNode("div", _hoisted_24, [
          _createElementVNode("ul", _hoisted_25, [
            _createElementVNode("li", null, [
              _createElementVNode("a", _hoisted_26, _toDisplayString(_ctx.$t('footer.terms')), 1)
            ]),
            _createElementVNode("li", null, [
              _createElementVNode("a", _hoisted_27, _toDisplayString(_ctx.$t('footer.privacy')), 1)
            ]),
            _createElementVNode("li", null, [
              _createVNode(_component_RouterLink, {
                to: "/terms-ads",
                class: "Footer-links-item--alt link-secondary--alt text-sm"
              }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_ctx.$t('footer.ads')), 1)
                ]),
                _: 1
              })
            ])
          ])
        ])
      ]),
      _createElementVNode("div", _hoisted_28, [
        _createElementVNode("div", _hoisted_29, [
          _createElementVNode("p", {
            class: "Footer-credits text-sm",
            innerHTML: _ctx.$t('footer.copyright')
          }, null, 8, _hoisted_30)
        ]),
        _createElementVNode("div", _hoisted_31, [
          _createElementVNode("p", {
            class: "Footer-credits text-sm",
            innerHTML: _ctx.$t('footer.responsibility')
          }, null, 8, _hoisted_32)
        ])
      ])
    ])
  ], 2))
}